import { render, staticRenderFns } from "./select-payment-plan.vue?vue&type=template&id=161b5d94"
import script from "./select-payment-plan.vue?vue&type=script&lang=js"
export * from "./select-payment-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports